<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Wallet Balance Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center" class="no-display">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        rounded
                        dense
                        required
                        v-model="current_academic_year"
                        :items="academic_year_list"
                        item-text="ay"
                        return-object
                        label="Academic Year"
                        outlined
                        persistent-hint
                        hint="Please Select Academic Year"
                    ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        rounded
                        dense
                        required
                        v-model="std"
                        :items="standard_list"
                        item-text="standard"
                        item-value="id"
                        label="Standard"
                        outlined
                        @change="getStandard();clear();"
                        persistent-hint
                        hint="Please Select Standard"
                    ></v-autocomplete>
                </v-col>
                <v-col sm="2" v-if="std != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="div" multiple :items="dision_list" item-text="div_name" item-value="div_off_id" label="Division" outlined @change="clear()"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" @change="clear()" :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col sm="2">
                    <v-btn rounded class="button mt-6" @click="getAllReport()" :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
             <v-col cols="12" sm="12" md="12" v-if="learner_info != ''" class="">
                <!-- <v-col sm="2">
                    <v-btn rounded  color="success" outlined @click="ExportToExcel();" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
                </v-col> -->
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn
                            class="ma-2 no-display"
                            rounded
                            color="success"
                            outlined
                            @click="
                fnExcelReport('my-table-id', 'installmentoutstandingreport')
              "
                            :loading="loader"
                        >
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="showLogo()">
                            Hide /Show Logo
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="printReport()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>

                    <!-- search code shiv -->
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field class="ma-2 no-display" v-model="search" append-icon="mdi-magnify" label="Search by Student name or by Registration Number" single-line hide-details></v-text-field>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <!-- header code -->
                        <v-simple-table></v-simple-table>
                        <div v-if="org_basic_data">
                            <v-row dense justify="center">
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.trust_logo && show_logo" align="center">
                                    <img :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                                </v-col>
                                <v-col cols="12" sm="4" md="8">
                                    <center>
                                        <h2>
                                            <strong>{{ org_basic_data.trust_name }}</strong>
                                        </h2>
                                        <h3>
                                            <strong>{{ org_basic_data.school_name }} </strong>
                                        </h3>
                                        <span>{{ org_basic_data.address }}</span> <br />
                                        <span>Phone :{{ org_basic_data.phone }} </span> <br />
                                        <span>Email :{{ org_basic_data.email }} </span> <br />
                                        <span>Website :{{ org_basic_data.website }} </span>
                                        <br />
                                    </center>
                                </v-col>
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo && show_logo">
                                    <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                                </v-col>
                            </v-row>
                        </div>
                        <div>
                            <center>
                                <b> <span>Wallet Balance Report </span></b>
                            </center>
                        </div>
                        <!-- header end -->
                        <v-simple-table dense class="elevation-1" fixed-header>
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Registration No.</th>
                                    <th class="">Name</th>
                                    <th class="">Mobile No.</th>
                                    <th class="">Quota</th>
                                    <th class="">Academic Year</th>
                                    <th class="">Admission Year</th>
                                    <th class="">Standard</th>
                                    <th class="">Division</th>
                                    <th class="">Wallet Balance</th>
                                    <th class="">Richarge History</th>
                                    <th class="">Billing History</th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="s in filteredItems" :key="s.id">
                                    <td>{{ s.sr_no }}</td>
                                    <td>{{ s.reg_no }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.primary_contact_number }}</td>
                                    <td>{{ s.quota }}</td>
                                    <td>{{ s.academicyear }}</td>
                                    <td>{{ s.learner_addmission_year }}</td>
                                    <td>{{ s.standard }}</td>
                                    <td>{{ s.div }}</td>
                                    <td>{{ s.balance }}</td>
                                    <td> 
                                        <span v-if="s.show_recharge">
                                           
                                             <v-btn icon> <v-icon color="black" @click="getrichargeHistory1(s.richarge_history)"> mdi-cash-100</v-icon></v-btn>
                                        </span> 
                                        <span v-else>
                                            --
                                        </span>
                                    </td>
                                     <td> 
                                        <span v-if="s.show_billing_history">
                                           <v-btn icon> <v-icon color="black" @click="getBillHistory1(s.lid)">mdi-cash-multiple</v-icon></v-btn>
                                        </span> 
                                        <span v-else>
                                            --
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
            </v-col>
              <v-dialog v-model="dialog_bill_details" persistent max-width="1500px">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                           Bill Details
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_bill_details=false"><v-icon> mdi-close </v-icon></v-btn>
                </v-toolbar>
                <v-col v-if="billing_history_details!=null" cols="12" sm="12" md="`12">
                    <span v-if="billing_history_details.transactiontype == 'Credit'">
                            <v-data-table v-if="billing_history_details.credit_history != ''" dense class="elevation-1 mytable" :headers="headers2" :items="billing_history_details.credit_history" fixed-header>
                            </v-data-table>
                    </span>
                     <span v-if="billing_history_details.transactiontype == 'Debit'">
                            <v-data-table v-if="billing_history_details.debit_history != ''" dense class="elevation-1 mytable" :headers="headers3" :items="billing_history_details.debit_history" fixed-header>
                            </v-data-table>
                    </span>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="show_bill_history" persistent max-width="1500px">
             <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                           Bill Details
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="show_bill_history=false"><v-icon> mdi-close </v-icon></v-btn>
                </v-toolbar>
                <v-row justify="center" dense>
                        <v-col cols="12" sm="12" md="12" lg="12">
                            <v-icon color="error">*</v-icon>
                            From Date ::
                            <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
                            <v-icon color="error" class="ml-3">*</v-icon>
                            To Date ::
                            <input class="mt-7 ml-2 pt-0" id="datePickerId" type="date" v-model="todate" />
                            <v-btn class="button" @click="getBillingHistory()">Proceed</v-btn>
                        </v-col>
                            <v-data-table v-if="billing_history != ''" dense class="elevation-1 mytable" :headers="headers1" :items="billing_history" fixed-header>
                            <template v-slot:item.details="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="black" @click="getBillHistory(item)">mdi-eye</v-icon></v-btn>
                                    </template>
                                    <span> View Details</span>
                                </v-tooltip>
                            </template>
                            </v-data-table>
                    </v-row>
             </v-card>
        </v-dialog>
        <v-dialog v-model="show_richarge_history" persistent max-width="1500px">
             <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                           Richarge Details
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="show_richarge_history=false"><v-icon> mdi-close </v-icon></v-btn>
                </v-toolbar>
            <v-row justify="center" dense>
                            <v-col cols="12" sm="12" md="12">
                        <v-data-table v-if="richarge_history != ''" dense class="elevation-1 mytable" :headers="headers" :items="bookList1" fixed-header @current-items="getFiltered"> 
                               <template v-slot:top class="pb-5">
                        <v-row justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete
                                                        class="mr-2 pb-5 pt-2"
                                                        flat
                                                        hide-details
                                                        small
                                                        rounded
                                                        dense
                                                        outlined
                                                        color="#0F2027"
                                                        :label="header.text"
                                                        multiple
                                                        clearable
                                                        :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"
                                                    ></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                        </v-data-table>
                        </v-col>
                        </v-row>
             </v-card>
        </v-dialog>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                show_bill_history:false,
                show_richarge_history:false,
                loader: false,
                color: "",
                snackbar: false,
                search: "",
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                stream: null,
                div: [],
                std: [],
                header: null,
                academic_year_list: null,
                standard_list: null,
                dision_list: null,
                stream_list: null,
                header_list: null,
                show: false,
                learner_info: [],
                data_list: [],
                component_headers: [],
                all_total_amount: null,
                all_total_paid: null,
                all_total_remaining: null,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
                org_basic_data: [],
                show_logo: true,
                 richarge_history:[],
             fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
            todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
            billing_history:[],
            billing_history_details:null,
            dialog_bill_details:false,
             filterArr: [],
                filters: {
                   transaction_type:[],
                   date:[],
                },
                 headers: [
                { text: "Sr No", value: "count" },
                { text: "Amount In Rs.", value: "amount" },
                { text: "Transaction Date", value: "date" },
                { text: "Transaction Type", value: "transaction_type" },
            ],
            headers1: [
                { text: "Sr No", value: "count" },
                { text: "Transaction Date", value: "date" },
                { text: "Debit Amount", value: "debit_amount" },
                { text: "Credit Amount", value: "credit_amount" },
                { text: "Balance Amount", value: "balance" },
                { text: "Details", value: "details" },
                
            ],
             headers3: [
                { text: "Canteen Menu", value: "canteenmenu" },
                { text: "Transaction Date", value: "date" },
                { text: "Order Id", value: "orderid" },
                { text: "Rate", value: "rate" },
                { text: "Quantity", value: "quantity" },
                { text: "Total Amount In Rs.", value: "canteentransactiondetails_amount" },
            ],

            headers2: [
                { text: "Amount In Rs.", value: "amount" },
                { text: "Transaction Date", value: "date" },
                { text: "Transaction Type", value: "transaction_type" },
                { text: "Payment Mode", value: "paymentmode" },
            ],
                lid:null,
            };
        },
        computed: {
            filteredItems() {
                return this.learner_info.filter((item) => {
                    return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || item.reg_no.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                });
            },
            bookList1() {
                return this.richarge_history.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
            getrichargeHistory1(richarge_history){
                this.richarge_history = richarge_history
                this.show_richarge_history = true
            },
              getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.richarge_history.map((d) => d[val]);
            },
             getBillHistory(item){
                this.billing_history_details = item
                this.dialog_bill_details = true
            },
            getBillHistory1(lid){
                this.lid = lid
                this.show_bill_history = true
            },
            getBillingHistory(){
                 const formData = {
                    learner_id: this.lid,
                    fromdate:this.fromdate,
                    todate:this.todate
                };
                axios
                    .post("/Wallet/getBillingHistory", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.billing_history = res.data.billing_history
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.flag_reasone);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {});
            },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                var blob = new Blob([tab_text], {
                    type: "application/vnd.ms-excel;charset=utf-8",
                });
                window.saveAs(blob, fileName);
            },
            showLogo() {
                if (this.show_logo) {
                    this.show_logo = false;
                } else {
                    this.show_logo = true;
                }
            },
            printReport() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            ExportToExcel() {
                var htmltable = document.getElementById("my-table-id");
                var html = htmltable.outerHTML;
                window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
            },
            clear() {
              this.learner_info=[]
            },
           
            getAllReport() {
                this.loader = true;
                this.search = "";
                const data = {
                    ay: this.current_academic_year.id,
                    std: this.std,
                    div: this.div,
                    status: this.status,
                };
                 axios
                    .post("/Wallet/walletBalanceReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_info = res.data.learner_info
                            this.org_basic_data = res.data.org_basic_data
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.flag_reasone);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.loader = false
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader = false
                    })
                    .finally(() => {
                        this.loader = false
                    });
               
            },
            getStandard() {
                const data = {
                    ay: this.current_academic_year.id,
                    std: this.std,
                };
                axios
                    .post("/InstallmentStructureDetails/getStandard", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dision_list = res.data.dision_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/InstallmentStructureDetails/getAllData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.ay_data;
                            this.current_academic_year = res.data.cay;
                            this.standard_list = res.data.standard_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    /* .scroll {
  overflow-x: scroll;
} */
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    .dt-button {
        font-size: small;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
        white-space: nowrap !important;
    }

    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        img {
            width: 100% !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        /* .stud-table {
    overflow-x: hidden !important;
  } */
        .box {
            background-color: white !important;
            /* margin: 8px !important;
    padding: 8px; */
            border: none !important;
            /* overflow: hidden !important; */
        }
        /* tr,
  td,
  th {
    font-size: large !important;
  } */

        @page {
            size: A4;
            margin-top: none !important;
            padding-top: none;
            /* size: 16in 17in; */
            size: 20in 17in;
        }
    }
    .trust-logo {
        width: 86%;
    }
    .schl-logo {
        width: 86%;
    }
    input[type="date"] {
  width: 30%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
.toolbar12 {
  background:#E57C23;/* #8360c3; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #E57C23
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #E57C23
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: white !important;
}
</style>
